$ = require('jquery');

$(function(){

    var scrollPos;

////////////////////////////////////////////
// sub menu clicks
////////////////////////////////////////////

var $subMenuLinks;
var headerHeight;

    function initAnchorlinks(){
        var $subnavmenu = $('.section.sub_nav .menu');
        headerHeight = $('#main_header').outerHeight();
        $subMenuLinks = $subnavmenu.find('a');

        $subMenuLinks.on('click', function(e){
            e.preventDefault();
            var $target = $( $(this).attr('href') );
            goToSection($target);
        });
    }



    function goToSection($target){
        if( $target.length ){
            var sectionPos = $target.position().top - headerHeight;
            $('html,body').animate({scrollTop: (sectionPos)}, 1200);
        }
    }

    //check on load to see if there is an achor in the URL

    var hash = window.location.hash;
    if( hash.length ){
      goToSection( $(hash));
    }



    function checkSubmenuLinks(){
        $subMenuLinks.each(function(i,v){
            var $target = $( $(this).attr('href') );
            if( $target.length ){
                var sectionPos = $target.position().top - (headerHeight * 2);
                var sectionHeight = $target.outerHeight();
                $(this).toggleClass('current', ( scrollPos > sectionPos && scrollPos < (sectionPos + sectionHeight) ) );
            }
        })
    }

    $(window).scroll(function(){
        scrollPos = $(window).scrollTop();
        checkSubmenuLinks();
    });


    initAnchorlinks();
    $('body').on('init', function(){
        initAnchorlinks();
    })



});